import { useDispatch, useSelector } from "react-redux";
import { cancelBatch as cancel } from "@/api/cancelBatch/cancelBatchApi";
import { useNotification } from "@/context/NotificationContext";
import { AppDispatch } from "@/app/store";
import { RootState } from "@/app/rootReducer";
import {
  setCancelError,
  setCancelLoading,
} from "@/modules/stochastic/features/CampaignBatchManagement/slices/batchSlice";

export function useCancelBatch() {
  const dispatch = useDispatch<AppDispatch>();
  const { showNotification } = useNotification();

  const loading = useSelector((state: RootState) => state.batch.cancelLoading);
  const error = useSelector((state: RootState) => state.batch.cancelError);

  const cancelBatch = async (
    batchId: number,
  ): Promise<{ success: boolean; message?: string }> => {
    dispatch(setCancelLoading(true));
    dispatch(setCancelError(null));

    try {
      const response = await cancel(batchId);

      const successMessage =
        response.data.message ||
        `Batch ${batchId} has been canceled successfully.`;

      showNotification(
        "Successfully canceled batch",
        successMessage,
        "success",
      );

      return { success: true, message: successMessage };
    } catch (err) {
      const errorMessage = `Batch ${batchId} was not canceled.`;

      dispatch(setCancelError(errorMessage));
      showNotification("Failed to cancel batch", errorMessage, "error");
      console.error("Failed to cancel batch:", err);

      return { success: false, message: errorMessage };
    } finally {
      dispatch(setCancelLoading(false));
    }
  };

  return { cancelBatch, loading, error };
}
